import attachmentsUrl from './attachments.html';
import PhotoswipeGallery from './photoswipeGallery';

class AttachmentsCtrl {
  constructor($scope, $element) {
    'ngInject';

    $scope.$evalAsync(() => {
      this.width = $element[0].clientWidth;
      // theoretically not needed but there is a glitch without it (at least in Chrome)
      $element.css('min-width', `${this.width}px`);
    }, 0);

    this.photoswipeGallery = new PhotoswipeGallery($element[0]);

    // prevent closing $uibModal by hitting esc in opened photoswipe gallery
    $scope.$on('modal.closing', (event, reason) => {
      if (reason === 'escape key press' && this.photoswipeGallery.gallery) {
        event.preventDefault();
      }
    });
  }

  $onChanges() {
    this.updateArbitraryHeight();
  }

  updateAttachmentEffectiveHeight(index, effectiveHeight) {
    this.mediaAttachments[index].effectiveHeight = effectiveHeight;
    this.updateArbitraryHeight();
  }

  updateArbitraryHeight() {
    if (!this.attachments) {
      return;
    }

    const isMedia = (attachment) =>
      attachment.mimetype.indexOf('image/') === 0 || attachment.mimetype.indexOf('video/') === 0;

    this.mediaAttachments = this.attachments.filter(isMedia);
    this.nonMediaAttachments = this.attachments.filter((attachment) => !isMedia(attachment));

    const effectiveHeights = this.mediaAttachments.map((a) => a.effectiveHeight);
    if (effectiveHeights.every((n) => n)) {
      this.arbitraryHeight = Math.max(...effectiveHeights);
    }
  }
}

export default {
  bindings: {
    attachments: '<',
  },
  templateUrl: attachmentsUrl,
  controller: AttachmentsCtrl,
  controllerAs: 'ctrl',
};
